import { render, staticRenderFns } from "./GenericReadonlyComponent.vue?vue&type=template&id=836de9fa"
import script from "./GenericReadonlyComponent.vue?vue&type=script&lang=js"
export * from "./GenericReadonlyComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports